export const BASIC_NEMESIS_CARDS_DB_KEY = 'basicNemesisCards-1.9'
